export function toSnakeCase(str: string, prefix = "ui"): string {
  const formattedString = str.toLowerCase().replace(/\s+/g, "_");
  return `${prefix}-${formattedString}`;
}
